<template>
  <section class="section section-observed home-portal" aria-label="首页信息门户">
    <div class="home-portal-grid">
      <div class="portal-block">
        <div class="portal-block__head">
          <h3>学会动态</h3>
          <button type="button" class="text-link" @click="front.goPath('/news-publish?board=society_dynamics')">更多 &gt;&gt;</button>
        </div>
        <ul class="portal-list portal-list--dated">
          <li v-for="item in dynamics" :key="itemKey(item)">
            <button type="button" class="portal-list__btn" @click="openItem(item)">
              <span class="portal-list__title">{{ item.title }}</span>
              <time v-if="item.date" class="portal-list__date">[ {{ item.date }} ]</time>
            </button>
          </li>
          <li v-if="!dynamics.length" class="portal-empty muted-copy">暂无内容</li>
        </ul>
      </div>

      <div class="portal-block">
        <div class="portal-block__head">
          <h3>工作进展</h3>
          <button type="button" class="text-link" @click="front.goPath('/news-publish?board=work_progress')">更多 &gt;&gt;</button>
        </div>
        <ul class="portal-list portal-list--dated">
          <li v-for="item in progress" :key="itemKey(item)">
            <button type="button" class="portal-list__btn" @click="openItem(item)">
              <span class="portal-list__title">{{ item.title }}</span>
              <time v-if="item.date" class="portal-list__date">[ {{ item.date }} ]</time>
            </button>
          </li>
          <li v-if="!progress.length" class="portal-empty muted-copy">暂无内容</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { listPublicCmsEntries, unwrapPublicPage } from '@/api/paleo'
import { preferHomepageEntries } from '@/utils/cmsExtra'

function toRows(result) {
  return unwrapPublicPage(result).rows || []
}

export default {
  name: 'HomePortalSection',
  inject: ['front'],
  data() {
    return {
      dynamics: [],
      progress: [],
      loadError: false
    }
  },
  created() {
    this.loadPortalData()
  },
  methods: {
    itemKey(item) {
      return item.entryId || item.contentId || item.title
    },
    mapRows(rows) {
      return (rows || []).map(row => this.front.mapCmsEntry(row))
    },
    /** 首页「学会动态 / 工作进展」仅展示后台勾选「在首页展示」的条目 */
    homepageRows(rows) {
      return preferHomepageEntries(this.mapRows(rows))
    },
    async loadPortalData() {
      try {
        const [dynamicsRes, progressRes] = await Promise.all([
          listPublicCmsEntries({ moduleCode: 'publish', columnCode: 'society_dynamics', pageNum: 1, pageSize: 8 }).catch(() => ({ rows: [] })),
          listPublicCmsEntries({ moduleCode: 'publish', columnCode: 'work_progress', pageNum: 1, pageSize: 8 }).catch(() => ({ rows: [] }))
        ])
        this.dynamics = this.homepageRows(toRows(dynamicsRes))
        this.progress = this.homepageRows(toRows(progressRes))
        this.loadError = false
      } catch (error) {
        this.loadError = true
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[HomePortalSection] load failed', error)
        }
      }
    },
    openItem(item) {
      if (!item) return
      const url = String(item.linkUrl || '').trim()
      if (/^https?:\/\//i.test(url)) {
        window.open(url, '_blank', 'noopener')
        return
      }
      if (url.startsWith('/')) {
        this.front.goPath(url)
        return
      }
      this.front.openContentDetail(item)
    }
  }
}
</script>

<style scoped>
.home-portal {
  padding-top: 0.25rem;
  padding-bottom: 0.5rem;
}

.home-portal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: stretch;
}

.portal-block {
  background: transparent;
  border: 0;
  padding: 0;
}

.portal-block__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.55rem;
  padding: 0 0 0.55rem;
  border-bottom: 2px solid #E5E1DA;
  background: transparent;
  color: inherit;
}

.portal-block__head h3 {
  margin: 0;
  position: relative;
  color: var(--primary, #002B49);
  font-size: 1.125rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.3;
  padding-bottom: 0.55rem;
  margin-bottom: -0.55rem;
  border-bottom: 2px solid var(--primary, #002B49);
}

.portal-block__head .text-link {
  color: var(--subtle, #6b7280);
  font-size: 0.8125rem;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.portal-block__head .text-link:hover {
  color: var(--primary, #002B49);
  text-decoration: underline;
}

.portal-list {
  list-style: none;
  margin: 0;
  padding: 0.15rem 0 0;
}

.portal-list__btn {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.15rem;
  border: 0;
  border-bottom: 1px dashed rgba(31, 79, 122, 0.12);
  background: transparent;
  cursor: pointer;
  color: #1a1a1a;
  font: inherit;
  border-radius: 0;
}

.portal-list li:last-child .portal-list__btn {
  border-bottom: 0;
}

.portal-list__btn:hover .portal-list__title {
  color: #C41E3A;
}

.portal-list__title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9375rem;
  line-height: 1.5;
}

.portal-list__date {
  flex-shrink: 0;
  font-size: 0.8125rem;
  color: #8a93a0;
  font-style: normal;
}

.portal-empty {
  padding: 0.65rem 0.1rem;
  margin: 0;
  color: var(--subtle, #6b7280);
  font-size: 0.875rem;
}

@media (max-width: 900px) {
  .home-portal-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
}
</style>
